export const userManagementColumns = [
  {
    key: 'first_name',
    label: 'user_management.columns.firstName',
  },
  {
    key: 'last_name',
    label: 'user_management.columns.lastName',
  },
  {
    key: 'contact_email',
    label: 'user_management.columns.email',
  },
  {
    key: 'user_actions',
    label: '',
  },
];
